// @flow
import {fetchQuery, graphql} from 'react-relay'
import {getRequest, createOperationDescriptor} from 'relay-runtime'
import environment from 'environment'

import util from 'utils/MiscUtils'
import type {fetchAvailableRolesQueryVariables as Variables}
  from './__generated__/fetchAvailableRolesQuery.graphql'

const query = graphql`
  query fetchAvailableRolesQuery($orgDatabaseId: String!, $count: Int!, $circleDatabaseId: String!) {
    organization(databaseId: $orgDatabaseId) {
      circle(databaseId: $circleDatabaseId) {
        availableRoles(first: $count) {
          edges {
            node {
              databaseId
              localizedName

              circle {
                localizedName
              }
            }
          }
        }
      }
    }
  }
`

const fetchRoles = (variables: Variables) => {
  const queryRequest = getRequest(query)
  const queryDescriptor = createOperationDescriptor(
    queryRequest,
    variables,
  )
  environment.retain(queryDescriptor)

  return new Promise((resolve, reject) => {
    fetchQuery(environment, query, variables, {fetchPolicy: 'store-or-network'}).subscribe({
      next: (data) => {
        resolve(data.organization?.circle?.availableRoles)
      },
      error: reject,
    })
  })
}

async function fetchAvailableRoles(variables: Variables): null | Promise<any> {
  try {
    return await fetchRoles(variables)
  } catch (err) {
    util.error('Expected roles to link to be fetched', err)
    return null
  }
}

export default fetchAvailableRoles
